<template>
  <v-container fluid>
    <section class="content-header">
      <v-toolbar dense dark color="#96298A">
        <v-toolbar-title>Pickups</v-toolbar-title
        ><v-divider class="mx-4" vertical />
        <v-text-field
          v-model="searcher"
          label="Buscar"
          single-line
          hide-details
          clearable
          max-width="200px"
          @keyup.enter="fillPickups()"
          @input="handleChangeSearch()"
        ></v-text-field
        ><v-tooltip bottom color="#96298A">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              ref="getData"
              icon
              @click="fillPickups()"
              x-large
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark> mdi-file-find </v-icon>
            </v-btn>
          </template>
          <span>Buscar</span>
        </v-tooltip>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-divider vertical />
          <v-tooltip bottom color="#96298A">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                @click="fillCbxShowModal()"
                x-large
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-database-plus</v-icon>
              </v-btn>
            </template>
            <span>Crear Nuevo</span>
          </v-tooltip>
          <v-divider vertical></v-divider>
          <v-tooltip bottom color="#96298A">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                @click="fillPickups()"
                x-large
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-table-refresh</v-icon>
              </v-btn>
            </template>
            <span>Actualizar Tabla</span>
          </v-tooltip>
          <v-divider class="mx-4" vertical />
          <v-switch
            v-model="pendientes"
            label="Pendientes"
            color="success"
            value="Pendientes"
            hide-details
            @change="fillPickups()"
          ></v-switch
          ><v-divider class="mx-4" vertical />
          <v-combobox
            label="Courier"
            v-model="asignado"
            :items="asignados"
            item-value="value"
            item-text="text"
            return-object
            clearable
          ></v-combobox
          ><v-divider class="mx-4" vertical />
          <v-combobox
            label="Origen"
            v-model="origen"
            :items="origenes"
            item-value="value"
            item-text="text"
            return-object
            clearable
          ></v-combobox>
        </v-toolbar-items>
      </v-toolbar>
    </section>
    <v-row>
      <v-col>
        <v-container fluid>
          <v-data-table
            :headers="headers"
            :items="pickups"
            class="elevation-1"
            :options.sync="options"
            :server-items-length="totalData"
          >
            <template v-slot:item.acciones="{ item }">
              <v-tooltip bottom color="#96298A">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="info"
                    @click="fillCbxShowModal(true, item)"
                    v-if="!item.finalizado && item.id_courier == 0"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Editar</span>
              </v-tooltip>
              <v-tooltip bottom color="#96298A">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="red"
                    @click="deleteItem(item)"
                    v-if="!item.finalizado && item.id_courier == 0"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Eliminar</span>
              </v-tooltip>
              <v-menu offset-y v-if="!item.finalizado && isCliente == 0">
                <template #activator="{ on: onMenu }">
                  <v-tooltip bottom color="#96298A">
                    <template #activator="{ on: onTooltip }">
                      <v-btn v-on="{ ...onMenu, ...onTooltip }" icon>
                        <v-icon>mdi-format-list-bulleted-type</v-icon>
                      </v-btn>
                    </template>
                    <span>Opciones</span>
                  </v-tooltip>
                </template>
                <v-list>
                  <v-list-item link dense @click="showModalCourier(item)">
                    <v-list-item-icon>
                      <v-icon>mdi-truck</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Asignar Información Adicional</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
            <template v-slot:item.finalizado="{ item }">
              <v-icon v-if="item.finalizado" color="green">mdi-check</v-icon>
              <v-icon v-else color="red">mdi-close</v-icon>
            </template>
            <template v-slot:item.horario="{ item }">
              {{ item.hora_recolecta }} - {{ item.cerrado_a }}
            </template>
            <template v-slot:item.creacion="{ item }">
              {{ formatDate(item.created_at) + ' / ' + formatDateTimeToTime(item.created_at) }}
            </template>
            <template v-slot:item.fecha_recolecta="{ item }">
              {{ formatDate(new Date(item.fecha_recolecta + 'T00:00:00')) }}
            </template>
          </v-data-table>
        </v-container>
      </v-col>
    </v-row>
    <!--FORMULARIO MODAL -->

    <v-dialog
      v-model="dialog"
      :fullscreen="fullScreen"
      transition="dialog-bottom-transition"
      persistent
      width="800"
    >
      <v-card elevation="24">
        <v-toolbar dark dense color="#96298A">
          <v-toolbar-title>Pickup</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-divider vertical />
            <v-btn v-if="!fullScreen" icon dark @click="fullScreen = true">
              <v-icon>mdi-window-maximize</v-icon>
            </v-btn>
            <v-btn v-if="fullScreen" icon dark @click="fullScreen = false">
              <v-icon>mdi-window-minimize</v-icon>
            </v-btn>
            <v-divider vertical></v-divider>
            <v-btn icon dark @click="closeAndResetCbx()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-divider vertical></v-divider>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="12" sm="12" md="4">
                <v-dialog
                  ref="dialogFecha"
                  v-model="modalFecha"
                  :return-value.sync="camposBD.fecha_recolecta"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="camposBD.fecha_recolecta"
                      label="Fecha"
                      append-icon="event"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="[reglas.requeridoTxt]"
                      required
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="camposBD.fecha_recolecta"
                    scrollable
                    no-title
                    :allowed-dates="allowedDates"
                    @input="
                      modalFecha = false;
                      $refs.dialogFecha.save(camposBD.fecha_recolecta);
                    "
                  >
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-dialog
                  ref="dialogHora"
                  v-model="modalHora"
                  :return-value.sync="camposBD.hora_recolecta"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="camposBD.hora_recolecta"
                      label="Hora"
                      append-icon="mdi-clock-time-four-outline"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="[reglas.requeridoTxt]"
                      required
                      :disabled="camposBD.fecha_recolecta == null"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-model="camposBD.hora_recolecta"
                    min="9:00"
                    max="17:00"
                    :allowed-hours="allowedHours"
                    :allowed-minutes="allowedMinutes"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialogHora.save(camposBD.hora_recolecta)"
                      >OK</v-btn
                    >
                  </v-time-picker>
                </v-dialog>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-dialog
                  ref="dialogHoraC"
                  v-model="modalHoraC"
                  :return-value.sync="camposBD.cerrado_a"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="camposBD.cerrado_a"
                      label="Cerrado a Las"
                      append-icon="mdi-clock-time-four-outline"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="[reglas.requeridoTxt]"
                      required
                      :disabled="camposBD.hora_recolecta == null"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-model="camposBD.cerrado_a"
                    :allowed-hours="allowedHoursC"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialogHoraC.save(camposBD.cerrado_a)"
                      >OK</v-btn
                    >
                  </v-time-picker>
                </v-dialog>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="camposBD.indicaciones"
                  label="Indicaciones"
                  append-icon="edit"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="6">
                <v-text-field
                  v-model="camposBD.cliente"
                  label="Cliente"
                  append-icon="handshake"
                  v-if="isCliente == 1"
                  readonly
                ></v-text-field>
                <v-combobox
                  v-model="cliente"
                  :items="clientes"
                  item-text="empresa"
                  item-value="empresa"
                  label="Cliente"
                  :rules="[reglas.requeridoCbx]"
                  required
                  append-icon="handshake"
                  return-object
                  v-if="isCliente == 0"
                ></v-combobox>
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field
                  v-model="camposBD.contacto"
                  label="Contacto"
                  append-icon="person"
                  required
                  :rules="[reglas.requeridoTxt]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="camposBD.direccion"
                  label="Dirección"
                  append-icon="map"
                  required
                  :rules="[reglas.requeridoTxt]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="6">
                <v-combobox
                  v-model="origenCbx"
                  :items="origenesCbx"
                  item-text="ciudad"
                  item-value="ciudad"
                  label="Origen"
                  :rules="[reglas.requeridoCbx]"
                  required
                  append-icon="mdi-map-marker-left"
                  return-object
                ></v-combobox>
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-combobox
                  v-model="ciudad"
                  :items="ciudades"
                  item-text="ciudad"
                  item-value="ciudad"
                  label="Destino"
                  :rules="[reglas.requeridoCbx]"
                  required
                  append-icon="mdi-map-marker-right"
                  return-object
                ></v-combobox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  v-model="camposBD.peso"
                  label="Peso"
                  type="number"
                  append-icon="calculate"
                  step="any"
                  min="0"
                  :rules="[reglas.requeridoTxt]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  v-model="camposBD.dimensiones"
                  label="Dimensiones"
                  append-icon="view_in_ar"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="4">
                <v-combobox
                  v-model="clase"
                  :items="clases"
                  item-text="text"
                  item-value="value"
                  label="Clase"
                  :rules="[reglas.requeridoCbx]"
                  required
                  append-icon="mdi-file-document-multiple"
                  return-object
                ></v-combobox>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-combobox
                  v-model="tipo"
                  :items="tipos"
                  item-text="tipo"
                  item-value="tipo"
                  label="Tipo"
                  :rules="[reglas.requeridoCbx]"
                  required
                  append-icon="checklist"
                  return-object
                ></v-combobox>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined color="error darken-1" @click="closeAndResetCbx()">
            Cancelar
            <v-icon dark>mdi-close</v-icon>
          </v-btn>
          <v-btn outlined color="primary darken-1" @click="saveItem()">
            Guardar
            <v-icon dark>mdi-content-save</v-icon>
          </v-btn>
        </v-card-actions>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>

    <!--FORMULARIO MODAL -->
    <!--MODAL COURIER-->
    <v-dialog
      v-model="dlgCourier"
      width="600"
      height="800"
      transition="dialog-bottom-transition"
      persistent
    >
      <v-card>
          <v-toolbar dark dense color="#96298A">
            <v-toolbar-title>Asignar Informacion</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-divider vertical></v-divider>
              <v-btn icon dark @click="cerrarModalCourier()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-divider vertical></v-divider>
            </v-toolbar-items>
          </v-toolbar>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-combobox
                v-model="courier"
                :items="couriers"
                item-text="nombre"
                item-value="id"
                label="Courier"
                append-icon="minor_crash"
                return-object
              ></v-combobox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-combobox
                v-model="estatus"
                :items="estatuses"
                item-text="descripcion"
                item-value="id"
                label="Estatus"
                append-icon="help_outline"
                return-object
              ></v-combobox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-textarea
                v-model="observacionesrecep"
                label="Observaciones"
                append-icon="edit"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-checkbox label="Finalizado" v-model="finalizado" hint="Luego de Finalizado no se podra agregar mas informacion!" persistent-hint></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer
          ><v-btn color="info" @click="actualizarCourier()" outlined>
            Guardar <v-icon>mdi-content-save-settings</v-icon></v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--MODAL COURIER-->
  </v-container>
</template>
<script>
import apicon from "../plugins/apicon";
import utils from "../utils/utils";
export default {
  created: function () {},
  data() {
    return {
      fullScreen: false,
      searcher: "",
      options: {},
      totalData: 0,
      dialog: false,
      valid: true,
      pendientes: false,
      isCliente: true,
      pickups: [],
      couriers: [],
      courier: null,
      cliente: null,
      clientes: [],
      estatus: null,
      estatuses: [],
      modalFecha: false,
      modalHora: false,
      modalHoraC: false,
      tipo: null,
      tipos: [
        { tipo: "Documentos" },
        { tipo: "No Documento" },
        { tipo: "Valija Diaria" },
        { tipo: "Pago" },
      ],
      clase: null,
      clases: [
        { value: "nacional", text: "Nacional" },
        { value: "exportacion", text: "Exportación" },
        { value: "cheque", text: "Cheque" },
      ],
      dlgCourier: false,
      observacionesrecep: null,
      finalizado : false,
      idPickup: 0,
      headers: [
        { text: "No.", value: "id" },
        { text: "Fecha Recolecta", value: "fecha_recolecta" },
        { text: "Horario", value: "horario" },
        { text: "Origen", value: "origen" },
        { text: "Indicaciones", value: "indicaciones" },
        { text: "Direccion", value: "direccion" },
        { text: "Clase", value: "clase" },
        { text: "Tipo", value: "tipo" },
        { text: "Guia", value: "guia.guia_interna" },
        {text: "Seguro", value: "guia.seguro"},
        { text: "Piezas", value: "guia.piezas" },
        { text: "Peso", value: "peso" },
        { text: "Courier", value: "courier.nombre" },
        { text: "Cliente", value: "cliente" },
        { text: "Contacto", value: "contacto" },
        { text: "Estatus", value: "estatus.descripcion" },
        { text: "Finalizado", value: "finalizado" },
        { text: "Creación", value: "creacion" },
        { text: "Digitador", value: "usuario.name" },
        { text: "Acciones", align: "end", value: "acciones", sortable: false },
      ],
      /*Variables*/
      camposBD: {
        id: 0,
        id_guia: null,
        fecha_recolecta: null,
        hora_recolecta: null,
        cerrado_a: null,
        cerrado: false,
        indicaciones: null,
        cliente: null,
        contacto: null,
        direccion: null,
        origen: null,
        destino: null,
        clase: null,
        tipo: null,
        peso: null,
        dimensiones: null,
      },
      asignados: [
        { value: "A", text: "Asignados" },
        { value: "NA", text: "No Asignados" },
      ],
      asignado: null,
      origenes: [
        { value: "QUITO", text: "QUITO" },
        { value: "GUAYAQUIL", text: "GUAYAQUIL" },
        { value: "ECO", text: "ECO" },
      ],
      origen: null,
      origenesCbx: [
        /*{ value: "QUITO", text: "QUITO" },
        { value: "GUAYAQUIL", text: "GUAYAQUIL" },
        { value: "ECO", text: "ECO" },*/
      ],
      origenCbx: null,
      ciudad: null,
      ciudades: [],
      msgerrpickup: null,
      modalEditando: false,
      /*Variables*/
    };
  },
  watch: {
    tipo: function (item) {
      if (item) {
        this.camposBD.tipo = item.tipo;
      }
    },
    cliente: function (item) {
      if (item) {
        this.camposBD.cliente = item.empresa;
      }
    },
    origenCbx: function (item) {
      if (item) {
        this.camposBD.origen = item.ciudad;
      }
    },
    ciudad: function (item) {
      if (item) {
        this.camposBD.destino = item.ciudad;
      }
    },
    clase: function (item) {
      this.camposBD.clase = item.value;
    },
    options: {
      handler() {
        this.fillPickups();
      },
      deep: true,
    },
    asignado: function () {
      this.fillPickups();
    },
    origen: function () {
      this.fillPickups();
    },
  },
  methods: {
    //Obtener los datos para rellenar la tabla del index
    fillPickups: async function () {
      const { page, itemsPerPage } = this.options;
      apicon
        .getDataApi(
          apicon.getApiBaseUrl() +
            "pickup?page=" +
            page +
            "&per_page=" +
            itemsPerPage +
            (this.searcher != null ? "&search=" + this.searcher : "") +
            (this.asignado != null ? "&asignado=" + this.asignado.value : "") +
            (this.origen != null ? "&origen=" + this.origen.value : "") +
            (this.pendientes ? "&pendientes=" + Boolean(this.pendientes) : "")
        )
        .then((result) => {
          this.pickups = result.data;
          this.totalData = result.total;
        });
    },
    fillCouriers:async function () {
      await apicon.getDataApi(apicon.getApiBaseUrl() + "courier").then((result) => {
        this.couriers = result;
      });
    },
    fillClientes: async function () {
      await apicon
        .getDataApi(apicon.getApiBaseUrl() + "usuario")
        .then((result) => {
          this.clientes = result;
        });
    },
    fillEstatuses:async function () {
      await apicon.getDataApi(apicon.getApiBaseUrl() + "estatusp").then((result) => {
        this.estatuses = result;
      });
    },
    showModalCourier: async function (item) {
      await this.fillCouriers();
      await this.fillEstatuses();
      //get the values
      this.courier = item.id_courier != null ? (this.couriers.find((c) => c.id === item.id_courier)) : null;
      this.estatus = item.id_estatus != null ? (this.estatuses.find((e) => e.id === item.id_estatus)) : null;
      this.observacionesrecep = item.observacionesrecep;
      console.log(item);
      this.dlgCourier = true;
      this.idPickup = item.id;
    },
    cerrarModalCourier: function () {
      this.idPickup = 0;
      this.courier = null;
      this.estatus = null;
      this.observacionesrecep = null;
      this.finalizado = false;
      this.dlgCourier = false;
      this.fillPickups();
    },
    actualizarCourier: function () {
      apicon
        .updateDataApi(apicon.getApiBaseUrl() + "pickup/" + this.idPickup, {
          id_courier: this.courier != null ? this.courier.id : null,
          id_estatus: this.estatus != null ? this.estatus.id : null,
          observacionesrecep: this.observacionesrecep,
          finalizado : this.finalizado,
        })
        .then((result) => {
          this.$swal(result.message);
          if(result.status){
            if(this.finalizado){
              this.cerrarModalCourier();
            }
          }
        });
    },
    //Guardar o Actualizar
    saveItem: function () {
      if (this.$refs.form.validate()) {
        //Actualizar
        if (this.modalEditando) {
          apicon
            .updateDataApi(
              apicon.getApiBaseUrl() + "pickup/" + this.camposBD.id,
              this.camposBD
            )
            .then((result) => {
              this.fillPickups();
              this.closeAndResetCbx();
              this.$swal(result.message);
            });
        } else {
          //Guardar
          apicon
            .saveDataApi(apicon.getApiBaseUrl() + "pickup", this.camposBD)
            .then((result) => {
              this.fillPickups();
              this.closeAndResetCbx();
              this.cliente = null;
              this.tipo = null;
              this.$swal(result.message);
            });
        }
      }
    },
    //Eliminar
    deleteItem: function (item) {
      var self = this;
      this.$swal(this.dswalEliminar).then((resultdlg) => {
        if (resultdlg.value) {
          apicon
            .deleteDataApi(apicon.getApiBaseUrl() + "pickup/" + item.id)
            .then((result) => {
              self.fillPickups();
              this.$swal(result.message);
            });
        }
      });
    },
    fillCbxShowModal: async function (editando = false, item = []) {
      this.modalEditando = editando;
      await this.fillClientes();
      if (this.isCliente == 1) {
        this.getEmpresaUsuario();
      }
      await this.getCiudadesEC();
      //this.showModal(editando, item);
      if (editando) {
        Object.keys(this.camposBD).forEach((key) => {
          this.camposBD[key] = item[key];
        });
        this.tipo = this.tipos.find((tip) => tip.tipo === item.tipo);
        this.cliente = this.clientes.find((cli) => cli.empresa === item.cliente);
        this.origenCbx = this.origenesCbx.find((or) => or.ciudad === item.origen);
        this.ciudad = this.ciudades.find((ciu) => ciu.ciudad === item.destino);
        this.clase = this.clases.find((cla) => cla.value === item.clase);
      } else {
        this.limpiarCampos();
      }
      this.dialog = true;
    },
    limpiarCampos: function () {
      Object.keys(this.camposBD).forEach((key) => {
        this.camposBD[key] = null;
      });
      this.cliente = null;
      this.origenCbx = null;
      this.ciudad = null;
      this.clase = null;
      this.tipo = null;
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    closeAndResetCbx: function () {
      this.limpiarCampos();
      this.dialog = false;
    },
    getEmpresaUsuario: function () {
      apicon
        .getDataApi(
          apicon.getApiBaseUrl() + "usuario/" + localStorage.getItem("userid")
        )
        .then((result) => {
          this.camposBD.cliente = result.empresa;
        });
    },
    handleChangeSearch: function () {
      if (this.searcher == null || this.searcher == "") {
        this.fillPickups();
      }
    },
    getCiudadesEC:async function () {
      await apicon
        .getDataApi(apicon.getApiBaseUrl() + "ciudadesec")
        .then((result) => {
          this.ciudades = result;
          this.origenesCbx = result;
        });
    },
    allowedDates: function (val) {
      return (
        val >= new Date().toISOString().substring(0, 10) &&
        new Date(val).getDay() != 6 &&
        new Date(val).getDay() != 5
      );
    },
    allowedHours: function (val) {
      return this.camposBD.fecha_recolecta ==
        new Date().toISOString().substring(0, 10)
        ? val >= new Date().getHours()
        : true;
    },
    allowedMinutes: function(val){
        return this.camposBD.fecha_recolecta ==
        new Date().toISOString().substring(0, 10)
        ? val >= new Date().getMinutes()
        : true;
    },
    allowedHoursC: function (val) {
      return (
        val >
        new Date(
          this.camposBD.fecha_recolecta + " " + this.camposBD.hora_recolecta
        ).getHours()
      );
    },
    formatDate: function(date){
            return utils.formatDate(date)
        },
    formatDateTimeToTime: function(date){
      return utils.formatDateTimeToTime(date);
    },
  },
  mounted() {
    apicon.setAuthHeaders();
    this.isCliente = localStorage.getItem("cliente");
  },
};
</script>
<style scoped>
.v-data-table.v-data-table.v-data-table >>> td {
  /*font-size: 0.8rem !important;*/
  padding: 4px;
}
.v-data-table.v-data-table.v-data-table >>> th {
  /*font-size: 0.8rem !important;*/
  padding: 4px;
}
</style>
